import { Button, DrinkIcon, EmptyState, formatBaht, Icons, Stepper } from "@jod/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useT } from "../features/i18n/index.ts";
import { useSession } from "../features/session/session-context.tsx";

export const Route = createFileRoute("/cart")({
  component: CartScreen,
});

function CartScreen() {
  const t = useT();
  const navigate = useNavigate();
  const { cart, cartTotalMinor, updateQty, submitOrder } = useSession();

  const submit = () => {
    submitOrder();
    navigate({ to: "/orders/$orderId", params: { orderId: "live" } });
  };

  return (
    <div className="mx-auto w-full max-w-md px-[18px] py-6">
      <button
        type="button"
        className="mb-4 flex items-center gap-1 text-cream-3 text-sm"
        onClick={() => navigate({ to: "/menu" })}
      >
        <Icons.IconBack size={18} /> {t("cart.backToMenu")}
      </button>
      <h1 className="h-display mb-5 text-[1.7rem]">{t("cart.title")}</h1>

      {cart.length === 0 ? (
        <EmptyState
          icon={<Icons.IconMenuGlyph size={28} />}
          title={t("cart.emptyTitle")}
          description={t("cart.emptyDesc")}
          action={
            <Button variant="ghost" onClick={() => navigate({ to: "/menu" })}>
              {t("cart.viewMenu")}
            </Button>
          }
        />
      ) : (
        <>
          <div className="space-y-2.5">
            {cart.map((line) => (
              <div key={line.id} className="glass flex items-center gap-3 rounded-lg p-3">
                <span className="grid size-12 shrink-0 place-items-center rounded-lg bg-[oklch(100%_0_0_/_5%)] text-gold">
                  <DrinkIcon name={line.iconName ?? "IconCocktail"} size={24} />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-display font-semibold text-cream text-sm">
                    {line.name}
                  </div>
                  <div className="text-gold text-xs">{formatBaht(line.priceMinor)}</div>
                </div>
                <Stepper
                  value={line.quantity}
                  onChange={(q) => updateQty(line.id, q)}
                  aria-label={t("cart.qtyAria", { item: line.name })}
                />
              </div>
            ))}
          </div>

          <div className="my-5 border-[var(--hairline)] border-t border-dashed" />

          <div className="flex items-center justify-between">
            <span className="text-cream-2">{t("cart.total")}</span>
            <span className="h-display text-[1.3rem] text-gold">{formatBaht(cartTotalMinor)}</span>
          </div>
          <p className="mt-1 text-cream-3 text-xs">{t("cart.payAtVenue")}</p>

          <Button size="lg" className="mt-5 w-full" onClick={submit}>
            {t("cart.submit")}
          </Button>
        </>
      )}
    </div>
  );
}
